import styled, { css } from 'styled-components';

interface FilterButtonProps {
  $bgColor: string;
  $bgColorActive: string;
  $textColor: string;
  $active: boolean;
}

export const S = {
  Container: styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: stretch;
    gap: 8px;
  `,


  FilterButton: styled.button<FilterButtonProps>`
    display: flex;
    width: auto; 
    align-items: center;
    gap: 6px;
    padding: 6px 12px 3px;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: bold;
    line-height: 1; /* crucial for vertical alignment */
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    background-color: ${({ $bgColor, $bgColorActive, $active }) => $active ? $bgColorActive : $bgColor};
    color: ${({ $textColor, $active }) => $active ? 'white' : $textColor};

    svg {
      width: 16px;
      height: 16px;
      margin: 0px 0px 4px 0px;
      display: inline-block;
      vertical-align: middle;
    }

    .label {
      display: inline-block;
      vertical-align: middle;
      line-height: 1;
    }

    ${({ $active }) =>
      $active &&
      css`
        box-shadow: 0 0 0 2px darkgray;
      `}
  `
};
